import Phaser from 'phaser';
import componentCoordinates from '../scenes/ComponentCoordinates';

export default class DailyBonusSprite extends Phaser.GameObjects.Container {
    constructor(scene, x, y, texture, imageScale) {
        super(scene, x, y);

        if (window.outerWidth >= 1200) {
            this.ourScale = componentCoordinates.desktop.scale;
            this.coordinates = componentCoordinates.desktop.coordinates;
        }else{
            this.ourScale = componentCoordinates.mobile.scale;
            this.coordinates = componentCoordinates.mobile.coordinates;
        }

        this.scene = scene;
        this.imageScale = imageScale;
        
        this.initImage(texture);
        this.scene.add.existing(this);
    }

    initImage(texture) {
        let image;
        if (texture.substring(0, 3) === "day") {
             image = this.scene.add.image(0, 0, 'bonus_images', texture).setScale(this.imageScale);
        }else{
             image = this.scene.add.image(0, 0, 'card_images', texture).setScale(this.imageScale);
        }
        this.add(image);
        this.checkMarkSprite = this.scene.add.sprite(this.coordinates.other.checkMark.x, this.coordinates.other.checkMark.y, 'bonus_images', 'claimed').setOrigin(0.5, 0.5).setScale(this.ourScale.checkMark).setVisible(false);
        this.add(this.checkMarkSprite);
    }

    showCheckMark() {
        this.checkMarkSprite.setVisible(true);
    }
}